import { onLoad, onReady } from "../../exports/dom";
import { tracking } from "../../exports/tracking";
import { defineEvent } from "../../exports/nexus";
import { lockInit, triggerGlobalInitIfReleased, unlockInit } from "./init/defer.js";
import { initDataTracker } from "./init/init.js";

/*                                                                   */
/*                                                           */
onReady.subscribe(initDataTracker);

/*                                                               */
/*                                                                   */
/*                                                                */
onLoad.subscribe(triggerGlobalInitIfReleased);

export default tracking.assignNamespace({
  lockInit,
  unlockInit,
  onInit: defineEvent(),
});
